import { makeStyles } from "@mui/styles";

export const useStyles = makeStyles(({ palette, spacing }) => ({
  button: {
    "& svg": { color: "#666666" },
    "&:hover": {
      backgroundColor: "#D9DCF0",
    },
    border: `solid 1px ${palette.primary.main}`,
    borderRadius: spacing(1.5),
    color: palette.primary.main,
    height: spacing(5),
    minWidth: spacing(5),
    padding: spacing(1),
    transition: "background-color .3s ease-out",
  },
  "button--active": {
    "& svg": { color: palette.common.white },
    "&:hover": {
      backgroundColor: palette.primary.main,
    },
    backgroundColor: palette.primary.main,
    color: palette.common.white,
    transition: "background-color .3s ease-out",
  },
}));
